/**
 * nucleus-performance-service API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ServiceRequestFilter { 
    value?: string;
    range?: ServiceRequestFilter.RangeEnum;
    from?: string;
    to?: string;
    user?: string;
    status?: number;
    method?: string;
    service?: string;
    pathLike?: string;
}
export namespace ServiceRequestFilter {
    export const RangeEnum = {
        Last5Minutes: 'LAST_5_MINUTES',
        Last15Minutes: 'LAST_15_MINUTES',
        Last30Minutes: 'LAST_30_MINUTES',
        Last1Hour: 'LAST_1_HOUR',
        Last3Hours: 'LAST_3_HOURS',
        Last6Hours: 'LAST_6_HOURS',
        Last12Hours: 'LAST_12_HOURS',
        Last24Hours: 'LAST_24_HOURS',
        Last3Days: 'LAST_3_DAYS',
        Last7Days: 'LAST_7_DAYS',
        Last30Days: 'LAST_30_DAYS',
        Last90Days: 'LAST_90_DAYS',
        Custom: 'CUSTOM'
    } as const;
    export type RangeEnum = typeof RangeEnum[keyof typeof RangeEnum];
}


